import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_16: FaireProductEntity = {
  token: "catalog_prod_prod-16",
  type: "product",
  name: "Reversible Lumbar Pillow - Best Day Ever, With Tassels - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 46.16,
  msrpDollars: 115.4,
  sku: "CO0016",
  caseSize: 3,
  material: "Metal",
  collectionToken: "col_confetti-cake",
  categoryTokens: ["catalog_cat_cats"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 341,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
